<template>
<div class="chapter">
<div class="inner_page">
<h1 class="plm_hd"><a href="#/Text/RUTH_contents">Chief abbreviations</a></h1>
<p class="abb_fo"><span class="smallcaps">av</span> – The Authorized (King James) Version of the Bible, 1611.</p>
<p class="abb_fo">Cooke – G. A. Cooke, <em class="italic">Ruth</em> (<span class="roman">The Cambridge Bible</span>, CUP, 1918).</p>
<p class="abb_fo">Eichrodt – W. Eichrodt, <em class="italic">Theology of the Old Testament</em>, 1 (ET, SCM Press, 1961).</p>
<p class="abb_fo"><span class="smallcaps">jb</span> – The Jerusalem Bible (Darton, Longman and Todd, 1966).</p>
<p class="abb_fo">Keil–Delitzsch – C. F. Keil and F. Delitzsch, <em class="italic">Biblical Commentary on the Old Testament: Ruth</em> (ET, Eerdmans, 1968).</p>
<p class="abb_fo">Knight – G. A. Knight, <em class="italic">Ruth and Jonah</em> (<span class="roman">Torch Bible Commentaries</span>, SCM Press, 1950).</p>
<p class="abb_fo">Knox – <em class="italic">The New Testament of Our Lord and Saviour Jesus Christ</em><span class="roman">,</span> translated by Ronald Knox (Burns, Oates and Washbourne, 1946).</p>
<p class="abb_fo">Leggett – D. A. Leggett, <em class="italic">The Levirate and Goel Institutions in the Old Testament</em> (Mack, NJ, 1974).</p>
<p class="abb_fo">Moffatt – <em class="italic">The New Testament: A New Translation</em> by James Moffatt (Hodder and Stoughton, revised edition, 1935).</p>
<p class="abb_fo">Morris – A. E. Cundall and L. Morris, <em class="italic">Judges and Ruth</em> (<span class="roman">Tyndale Old Testament Commentaries</span>, Inter-Varsity Press, 1968).</p>
<p class="abb_fo"><span class="smallcaps">neb</span> – The New English Bible (NT 1961, <span class="roman">2nd edition </span>1970; OT 1970).</p>
<p class="abb_fo"><span class="smallcaps">niv</span> – The New International Version of the Bible (Hodder and Stoughton, 1979, 1984, 2011).</p>
<p class="abb_fo"><span class="smallcaps">nrsv</span> – The New Revised Standard Version of the Bible (NT 1946, <span class="roman">2nd edition </span>1971; OT 1952; 1995).</p>
<p class="abb_fo">Rowley – H. H. Rowley, ‘The Marriage of Ruth’, in <em class="italic">The Servant of the Lord and Other Essays</em> (Blackwell, <span class="roman">2nd edition </span>1965).</p>
<p class="abb_fo"><span class="smallcaps">rsv</span> – The Revised Standard Version of the Bible (NT 1946, <span class="roman">2nd edition </span>1971; OT 1952).</p>
<p class="abb_fo">de Vaux – Roland de Vaux, <em class="italic">Ancient Israel</em> (Darton, Longman and Todd, <span class="roman">3rd edition </span>1973).</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// RUTH_abbrev.vue?1ba18aac